import React, {Component} from "react";
import styled, {keyframes} from "styled-components";
import {ArrowRightCircle} from "react-feather";
import {ChevronsDown} from "react-feather";
import AnchorLink from "react-anchor-link-smooth-scroll";

import {
  LargeTitle,
  ContainWPadding,
  HugeTitle,
  SmallTitle,
  primary,
  Margin,
  SmallMargin,
  SplashTitle,
  MediumTitle,
  LongArrowWhite,
  SplashTitleMobile,
  mediaMaxPhone
} from "../Tools/Variables";
import BgImg from "../Images/betongsang.jpg";

const Wrapper = styled.div `
  position: relative;
  width: 100vw;
  min-height: 100vh;
  max-height: 1700px;
  background-size: cover;
  background-position: left;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Overlay = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background: #000000;
  opacity: 0.6;
  z-index: 1;
`;

const TextContainer = styled.div `
  position: relative;
  flex-direction: column;
  line-height: 2;
  margin-left: 20px;
  margin-top: 32vh;

  color: white;
  z-index: 2;

  @media screen and (${mediaMaxPhone}) {
    margin-top: 100px;
    margin-left: 0px;
  }
`;

const InterestBtn = styled.button `
  font-family: inherit;
  color: inherit;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 300;
  min-height: 50px;
  line-height: 50px;
  background: none;
  margin: 30px 0 100px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;

  border: none;
`;

const Marked = styled.span `
  position: relative;
`;

export const AnimateMarked = keyframes `

  from {

    transform: scaleX(0);
  }
  to {
    
    transform: scaleX(1);
  }
  
}
`;

const MarkedOverlay = styled.span `
backface-visibility: hidden;
  height: 2px;
  width: 100%;
  transform: scaleX(0);
  z-index: -1;
  opacity: 1;
  position: absolute;
  bottom: -5px;
  background: ${primary};
  transform-origin: left;
  animation: ${AnimateMarked} 1.5s ease-in-out forwards;
  animation-delay: 2s;
`;

export const AnimateContinue = keyframes `

  from {

    opacity: 0;
    transform: translateY(0);
  }
  50%{
    opacity: 1;
  }
  to {
    opacity: 0.5;
    transform: translateY(10px);
    
  }
  
}
`;

const ContinueBtn = styled.button `
  opacity: 0;
  background: none;
  border: none;

  cursor: pointer;
  position: absolute;
  color: white;
  margin: 0 auto;

  height: 50px;
  width: 50px;
  width: 100%;
  left: 0;
  bottom: 5vh;
  z-index: 1;

  animation: ${AnimateContinue} 5s ease-in-out infinite alternate;

  animation-delay: 3.5s;
`;

const SplashLine = styled.div `
  display: inline-block;
  height: 4px;
  width: 80px;
  background: white;
  margin-bottom: 20px;
  margin-left: -20px;
`;

class Splash extends Component {
  render() {
    return (
      <Wrapper style={{
        backgroundImage: "url(" + BgImg + ")"
      }}>
        <ContainWPadding>
          <TextContainer>
            <SplashTitle removeMobile>Sängrevolutionen</SplashTitle>
            <SplashTitle removeMobile>Är här</SplashTitle>
            <SplashTitleMobile>Säng–</SplashTitleMobile>
            <SplashTitleMobile>
              revolutionen är här
              <SmallMargin/>
            </SplashTitleMobile>
            <div>
              <MediumTitle
                style={{
                fontWeight: 200,
                maxWidth: 550,
                transformStyle: 'preserve-3d'
              }}>
                Vakna utsövd, varje natt, hela livet. Låter det som en önskedröm? Inte med en
                handgjord premiumsäng från Modilect. Med
                <Marked>
                  {" "}
                  <MarkedOverlay/>
                  fjärrkontroll
                </Marked>{" "}
                kan du steglöst{" "}
                <Marked>
                  <MarkedOverlay/>
                  justera fastheten.
                </Marked>{" "}
                Sov i en säng som du anpassar efter dina behov – inte tvärtom.
              </MediumTitle>
              <InterestBtn
                id={'IntrModalBtn_Splash'}
                onClick={this.props.setShowContactModal}>
                <div
                  style={{
                  marginRight: 10
                }}
                  id={'IntrModalBtn_SplashBg'}>
                  Intresseanmälan
                </div>
                <LongArrowWhite
                  style={{
                  height: 10,
                  margin: "auto"
                }}/>
              </InterestBtn>
            </div>
          </TextContainer>
          <Overlay/>
        </ContainWPadding>
        <AnchorLink offset="150" href="#controllSection">
          <ContinueBtn>
            <ChevronsDown
              size={30}
              style={{
              margin: "0 auto",
              color: primary
            }}/>
          </ContinueBtn>
        </AnchorLink>
      </Wrapper>
    );
  }
}

export default Splash;



// WEBPACK FOOTER //
// ./src/Home/Splash.js